import { render, staticRenderFns } from "./OperacionesStatusEditor.vue?vue&type=template&id=52ef67ad&"
import script from "./OperacionesStatusEditor.vue?vue&type=script&lang=js&"
export * from "./OperacionesStatusEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports